// "Do Not Display" ACF checkbox on Brands and Products. A flagged entry stays
// published in WP (the Deals page still reads its name/image) but has no public
// page on herb.co, so nothing should link to it
const isHiddenFromSite = node =>
  node?.BnPDisplaySettings?.donotdisplay === true;

module.exports = isHiddenFromSite;
